import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import type { IPath } from '@feathr/blackbox';

import styles from './PathPreview.css';

interface IProps {
  path: IPath;
}

function PathPreview(props: IProps) {
  const { path } = props;
  const { t } = useTranslation();

  return (
    <section className={styles.root}>
      <h4>{t('Goal:')}</h4>
      <p>{path.shared_description}</p>
      {path.legs.map((leg, index) => (
        <Fragment key={index}>
          <h5>
            {t('Leg {{number}}: {{name}}', {
              number: index + 1,
              name: leg.name,
            })}
          </h5>
          <ul>
            {leg.campaigns.length === 0 && <li>{t('No campaigns in this leg')}</li>}
            {leg.campaigns
              .filter((cpn) => !!cpn)
              .map((campaign, i) => (
                <li key={campaign.id || i}>{campaign.placeholder ?? campaign.name}</li>
              ))}
          </ul>
        </Fragment>
      ))}
    </section>
  );
}

export default PathPreview;
